import React from 'react';
import { Search, Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function Topbar({ breadcrumb, title, onSearch, notificationCount = 0 }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'fr';

  return (
    <div className="h-14 bg-white border-b border-slate-200 sticky top-0 z-20 flex items-center px-6 gap-4">
      {/* Title area */}
      <div className="flex-shrink-0">
        {breadcrumb && <div className="text-[11px] text-slate-400">{breadcrumb}</div>}
        {title && <div className="text-[14px] font-semibold tracking-tight">{title}</div>}
      </div>

      {/* Search */}
      <div className="flex-1 max-w-sm relative">
        <Search
          size={13}
          strokeWidth={1.75}
          className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none"
        />
        <input
          className="w-full bg-slate-50 border border-slate-200 rounded-md h-8 pl-8 pr-14 text-[12.5px] outline-none focus:border-teal-600 placeholder:text-slate-400"
          placeholder={t('topbar.search_placeholder')}
          onChange={(e) => onSearch?.(e.target.value)}
        />
        <kbd className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] bg-white border border-slate-200 px-1.5 py-0.5 rounded text-slate-500 font-mono pointer-events-none">
          ⌘K
        </kbd>
      </div>

      {/* Right */}
      <div className="ml-auto flex items-center gap-2">
        {/* Language switcher */}
        <div className="flex items-center rounded-md border border-slate-200 overflow-hidden text-[11px] font-semibold">
          {['fr', 'en'].map((l) => (
            <button
              key={l}
              onClick={() => i18n.changeLanguage(l)}
              className={`px-2.5 h-7 transition ${
                lang === l
                  ? 'bg-primary text-white'
                  : 'text-slate-500 hover:bg-slate-50'
              }`}
            >
              {l.toUpperCase()}
            </button>
          ))}
        </div>

        <button className="relative w-8 h-8 grid place-items-center text-slate-500 hover:bg-slate-100 rounded-md transition">
          <Bell size={16} strokeWidth={1.75} />
          {notificationCount > 0 && (
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-accent ring-2 ring-white" />
          )}
        </button>
      </div>
    </div>
  );
}

export default Topbar;
